import { render, staticRenderFns } from "./LeftTop.vue?vue&type=template&id=6c1f12e0&scoped=true"
import script from "./LeftTop.vue?vue&type=script&lang=js"
export * from "./LeftTop.vue?vue&type=script&lang=js"
import style0 from "./LeftTop.vue?vue&type=style&index=0&id=6c1f12e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1f12e0",
  null
  
)

export default component.exports